// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__J-Aql","large":"styles_large__1Q_Lz"};